import { UIController } from '@hcie/ui-components';
import { initUICoordinator } from '../../editor/ui-coordinator';
import { initPWA } from './pwa-handler';

new UIController().init();
initUICoordinator();
initPWA();

